export default "__VITE_ASSET__B3N_LoCa__"